import type { CtcaeVersion, RecentTerm, StoredTerm } from "./types";

const KEY = "perprotocol.ctcae.state.v1";
const MAX_RECENT = 15;

type LocalState = {
  preferredVersion: CtcaeVersion;
  recentTerms: RecentTerm[];
  savedTerms: StoredTerm[];
};

const fallback: LocalState = { preferredVersion: "6.0", recentTerms: [], savedTerms: [] };

export function loadLocalState(): LocalState {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY) ?? "null") as Partial<LocalState> | null;
    if (!parsed) return fallback;
    return {
      preferredVersion: parsed.preferredVersion === "5.0" ? "5.0" : "6.0",
      recentTerms: Array.isArray(parsed.recentTerms) ? parsed.recentTerms.slice(0, MAX_RECENT) : [],
      savedTerms: Array.isArray(parsed.savedTerms) ? parsed.savedTerms : [],
    };
  } catch {
    return fallback;
  }
}

function persist(state: LocalState) {
  localStorage.setItem(KEY, JSON.stringify(state));
  return state;
}

export function setPreferredVersion(version: CtcaeVersion) {
  const state = loadLocalState();
  return persist({ ...state, preferredVersion: version });
}

export function addRecent(term: StoredTerm, now = new Date().toISOString()) {
  const state = loadLocalState();
  const recentTerms = [
    { ...term, viewedAt: now },
    ...state.recentTerms.filter((item) => item.recordId !== term.recordId),
  ].slice(0, MAX_RECENT);
  return persist({ ...state, recentTerms });
}

export function toggleSaved(term: StoredTerm) {
  const state = loadLocalState();
  const exists = state.savedTerms.some((item) => item.recordId === term.recordId);
  const savedTerms = exists
    ? state.savedTerms.filter((item) => item.recordId !== term.recordId)
    : [term, ...state.savedTerms];
  return persist({ ...state, savedTerms });
}

export const storageKey = KEY;
